import { IImpact, IImpactBase, IUnSdg } from 'src/types'


/**
* Returns unique UN SDGs (by id) found across the given impacts, preserving first-seen order.
*/
export function getUniqueUnSdgsFromImpacts(impacts: Array<IImpactBase | null | undefined>): IUnSdg[] {
  const byId = new Map<string, IUnSdg>()
  for (const im of impacts || []) {
    if (!im?.un_sdg) continue
    for (const s of im.un_sdg) if (s?.id && !byId.has(s.id)) byId.set(s.id, s)
  }
  return [...byId.values()]
}

export function getSdgNumberFromName(name?: string): number {
  if (!name) return Number.MAX_SAFE_INTEGER
  const m = /^\s*(\d{1,2})\s*[:.-]?/.exec(name)
  return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER
}

interface AggregateImpactsParams {
  accountImpacts?: Array<IImpact | null | undefined> | null
  productImpacts?: Array<IImpact | null | undefined> | null
  stepsImpacts?: Array<IImpact | null | undefined> | null
}

interface AggregateImpactsResult {
  impactsToShow: IImpact[]
  isImpactsPage: boolean
}

export function aggregateImpacts({
  accountImpacts,
  productImpacts,
  stepsImpacts,
}: AggregateImpactsParams): AggregateImpactsResult {
  const allImpacts = [
    ...(stepsImpacts ?? []),
    ...(productImpacts ?? []),
    ...(accountImpacts ?? []),
  ].filter((impact): impact is IImpact => Boolean(impact))

  const impactsToShow = []
  const uniqueImpacts = new Map<string, IImpact>()

  for (const impact of allImpacts) {
    if (!impact.home_page_show) continue
    if (!uniqueImpacts.has(impact.id)) {
      uniqueImpacts.set(impact.id, impact)
      impactsToShow.push(impact)
    }
  }

  const isImpactsPage = allImpacts.some((impact) => impact.impacts_page_show)

  return {
    impactsToShow,
    isImpactsPage,
  }
}
